import { GroupContextType } from './groupContextType';

export const isCustomerContextType = (type: GroupContextType | null) =>
    type === GroupContextType.CUSTOMER_GROUP || type === GroupContextType.CUSTOMER_COMPANY;

export const isSupplierContextType = (type: GroupContextType | null) =>
    type === GroupContextType.SUPPLIER_GROUP || type === GroupContextType.SUPPLIER_COMPANY;

export const isGroupContextType = (type: GroupContextType | null) =>
    type === GroupContextType.CUSTOMER_GROUP || type === GroupContextType.SUPPLIER_GROUP;

export const isCompanyContextType = (type: GroupContextType | null) =>
    type === GroupContextType.CUSTOMER_COMPANY || type === GroupContextType.SUPPLIER_COMPANY;
